import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { CategoryView } from 'ish-core/models/category-view/category-view.model';
import { CategoryRoutePipe } from 'ish-core/routing/category/category-route.pipe';

@Component({
  selector: 'custom-dot-cms-uve-category-card',
  templateUrl: './dot-cms-uve-category-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, RouterLink, CategoryRoutePipe],
})
export class DotCmsUveCategoryCardComponent implements OnChanges {
  readonly stylesCSS = input<string>(undefined);
  readonly category = input<CategoryView>(undefined);
  readonly layout = input<string>(undefined);

  categoryImageUrl = '/assets/img/not-available.svg';

  ngOnChanges() {
    this.setCategoryImageUrl();
  }

  /**
   * Set the category image URL from the (non-)empty property effectiveUrl.
   * The URL to a non-empty effectiveUrl has a prefix URL of property icmBaseURL.
   */
  setCategoryImageUrl() {
    const category = this.category();
    if (category.images?.[0]?.effectiveUrl?.length > 0) {
      this.categoryImageUrl = `${category.images[0].effectiveUrl}`;
    }
  }
}
